import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default (data) => {
	let headers = null;
	if (!(data instanceof FormData)) {
		headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
	}

	return fetch(Methods.PATCH, EndPoints.USER, data, headers, true);
};
